import { EIconNames } from '@idaho-aeyc/ui-kit';
import { FC } from 'react';

export type PublicRouteType = {
  component: FC<unknown>;
  path: string;
};

export type PrivateRouteType = {
  component: FC;
  path: string;
  show: boolean;
  showByPermissions?: boolean;
  icon?: EIconNames | React.ReactNode;
  selectedIcon?: EIconNames | React.ReactNode;
  title?: string;
  subRoutes?: PrivateRouteType[];
  dataCy?: string;
};

export type SubRouteType = Omit<PrivateRouteType, 'selectedIcon' | 'icon'>;

export enum RoutesPaths {
  LOGIN = 'login',
  RESET_PASSWORD = 'reset-password',
  WORKSHOP = 'workshop',
  FAMILY = 'family',
  FAMILY_EVENTS = 'family/events',
  SETTINGS = 'settings',
  TEAM = 'settings/team',
  LIGHT_BOX = 'settings/lightbox',
  SECURITY = 'settings/security',
  SETTINGS_DUPLICATE_MERGE = 'settings/duplicate-merge',
  ORGANIZATION = 'organization',
  ORGANIZATION_DETAILS = 'organization/:id',
  ORGANIZATION_DETAILS_INPUTS_OUTPUTS = 'organization/:id/inputs-outputs',
  PEOPLE = 'people',
  PEOPLE_DETAILS = 'people/:id',
  PEOPLE_DETAILS_INPUTS_OUTPUTS = 'people/:id/inputs-outputs',
  WORKSHOP_DETAILS = 'workshop/:id',
  WORKSHOP_DETAILS_INPUTS_OUTPUTS = 'workshop/:id/inputs-outputs',
  WORKSHOP_DISCOVERY = 'workshops',
  WORKSHOP_CANCEL_REGISTRATION = 'workshop/:language/registation/cancel/:workshopId/:id',
  WORKSHOP_CANCEL_REGISTRATION_NOT_FOUND = 'workshop/en/registation/cancel/404',
  KIT_MANAGEMENT = 'kit-management',
  KIT_MANAGEMENT_WORKSHOP = 'kit-management/workshop',
  KIT_MANAGEMENT_PARENTS = 'kit-management/parents',
  PAGE_NOT_FOUND = '404',
  SUBSCRIBERS = 'subscribers',
  SUBSCRIBERS_NOTIFY = 'subscribers/notify',
  SUBSCRIBERS_WAIT_LIST = 'subscribers/wait-list',
  ELCS = 'elc',
  ELC_DETAIL = 'elc/:id',
  ELC_DETAIL_INPUTS_OUTPUTS = 'elc/:id/inputs-outputs',
  ELC_PILLARS_OF_STRENGTH = 'elc/:id/pillars-of-strength/:pillarId',
  ELC_ACTION_PLAN = 'elc/:id/action-plan',
  ALL_ELCS_ACTION_PLAN = 'elc/action-plan',
  MYELCS = 'my-elc',
  MYELCS_DETAIL = 'my-elc/:id',
  MYELCS_DETAIL_INPUTS_OUTPUTS = 'my-elc/:id/inputs-outputs',
  MYELCS_PILLARS_OF_STRENGTH = 'my-elc/:id/pillars-of-strength/:pillarId',
  MYELCS_ACTION_PLAN = 'my-elc/:id/action-plan',
  PILLARS_OF_STRENGTH = 'pillars-of-strength/:id',
  REPORTS = 'reports',
  EVENTS = 'events',
  EVENTS_BY_ID = 'events/:id',
  EVENTS_BY_ID_INPUTS_OUTPUTS = 'events/:id/inputs-outputs',
  PROFILE = 'profile/:id',
}
